var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixAccordion from "@radix-ui/react-accordion";
var Root = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(RadixAccordion.Root, __assign({}, otherProps, { children: children })));
};
var Item = function (_a) {
    var otherProps = __rest(_a, []);
    return (_jsx(RadixAccordion.Item, __assign({}, otherProps)));
};
var Header = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(RadixAccordion.Header, __assign({}, otherProps, { children: children })));
};
var Content = function (_a) {
    var otherProps = __rest(_a, []);
    return (_jsx(RadixAccordion.Content, __assign({}, otherProps)));
};
var Trigger = function (props) { return (_jsx(RadixAccordion.Trigger, __assign({}, props))); };
export { Root, Header, Content, Trigger, Item };
